import React from 'react';
import { useSelector } from 'react-redux';
import { deviceDisplayTypes } from 'common/utils/constants';
import { Link } from 'react-router-dom';
import { DeviceCheckBox } from '../DeviceCheckBox';

const DeviceTableEchoIdAndNameCell = ({ row, forAlarmMap, onlyDeviceId }) => {
  let deviceNameValues = {
    ...(row.value?.id && { deviceID: row.value.id }),
    ...(row.value?.tags?.userLabel && { userLabel: row.value.tags.userLabel })
  };
  const echoTab = useSelector((store) => store.ui.devicesPage.echoTab);
  // const activeTab = useSelector((store) => store.ui.devicesPage.activeTab);
  let displayType = echoTab?.deviceDisplayMode ?? deviceDisplayTypes.ID;

  // const devicesPage = useSelector((store) => store.ui.devicesPage);
  // const activeTab = devicesPage.activeTab;
  // let displayType;
  // switch (activeTab) {
  //   case DEVICES_PAGE_TAB.pivot:
  //     displayType = devicesPage.pivotTab.deviceDisplayMode;
  //     break;
  //   case DEVICES_PAGE_TAB.echo:
  //     displayType = devicesPage.echoTab.deviceDisplayMode;
  //     break;
  //   case DEVICES_PAGE_TAB.all:
  //     displayType = devicesPage.allDevicesTab.deviceDisplayMode;
  //     break;
  //   default:
  //     displayType = deviceDisplayTypes.ID;
  // }
  let defaultDeviceAccessor = deviceNameValues.deviceID ? deviceNameValues.deviceID : '';
  let targetDeviceDisplay = null;

  switch (displayType) {
    case deviceDisplayTypes.ID:
      targetDeviceDisplay = defaultDeviceAccessor;
      break;
    case deviceDisplayTypes.NAME:
      targetDeviceDisplay = deviceNameValues.userLabel ? deviceNameValues.userLabel : defaultDeviceAccessor;
      break;
    default:
      targetDeviceDisplay = defaultDeviceAccessor;
  }

  return (
    <div id="DeviceTable_cellWrapper" className="idColumn DeviceTable_cellWrapper">
      {forAlarmMap || onlyDeviceId ? null : <DeviceCheckBox deviceTwin={row.value} targetDeviceID={row.value.id} />}
      {!onlyDeviceId ? (
        <Link to={'/console/devices/echo/overview?deviceId=' + row.value.id} data-tip={targetDeviceDisplay}>
          {targetDeviceDisplay}
        </Link>
      ) : (
        <div id="DeviceTable_cellWrapper" className="DeviceTable_cellWrapper" data-tip={row.value.id}>
          {row.value.id}
        </div>
      )}
    </div>
  );
};

export default DeviceTableEchoIdAndNameCell;
